// extracted by mini-css-extract-plugin
export default {"disconnect-successful-form":"OFjSM","disconnectSuccessfulForm":"OFjSM"};